import { Injectable } from '@angular/core';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, MANAGE_MODAL_CONST } from '../common/core/common.constants';
import { DatePipe } from '@angular/common';
import { AlertConfirmPopupComponent, AlertConfirmPopupService } from 'src/app/common/alert-confirm-popup';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from './utils.service';
import { environment } from '../../environments/environment';
import { NoLinesModalComponent } from '../home/components/no-lines-modal/no-lines-modal.component';

@Injectable({
  providedIn: 'root'
})
export class IotService {
  ngbModalOptions: NgbModalOptions;
  ref: any;
  authoringContentData: any;
  constructor(private datepipe: DatePipe, private alertModal: AlertConfirmPopupService, private modalService: NgbModal, public utilsSvc: UtilsService) { 
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
  }

  getAgreementFromIotResponse(product){
    if(product?.agreements){
      return product.agreements.term +" "+ product.agreements.termUnit?.slice(0,2);
    }
    return COMMON_CONSTANTS.DOUBLE_HYPHEN
  }

  date_or_renewalDate_formatChange(date,renewalDate?){
    if(date){
      let datenew =new Date(date);
      return renewalDate?this.datepipe.transform(datenew.setDate(datenew.getDate() + COMMON_CONSTANTS.DIGITS.ONE),
      MANAGE_MODAL_CONST.DATE_FORMAT_MM_DD_YYYY):this.datepipe.transform(datenew,MANAGE_MODAL_CONST.DATE_FORMAT_MM_DD_YYYY);   
    }
    return COMMON_CONSTANTS.DOUBLE_HYPHEN
  }
  autoRenew(data){
    if(this.utilsSvc.isNotNullOrUndefined(data)){
      if(environment.ENABLE_5G_ANS){
        if(data === this.authoringContentData?.manageLine?.autoRenewOnTxt){
          return MANAGE_LINE_CONST.AUTO_PAY_ON;
        }else if(data === this.authoringContentData?.manageLine?.autoRenewOffTxt){
          return MANAGE_LINE_CONST.AUTO_PAY_OFF;
        }else{
          return COMMON_CONSTANTS.DOUBLE_HYPHEN;
        }        
      }else{
         return data? MANAGE_LINE_CONST.AUTO_PAY_ON : MANAGE_LINE_CONST.AUTO_PAY_OFF;
      }         
    }else{
      return COMMON_CONSTANTS.DOUBLE_HYPHEN;
    }
  }
  openTooltip(autoRenew,endDate?,renewalDate?){
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    if(autoRenew === MANAGE_LINE_CONST.AUTO_PAY_OFF){
      this.alertModal.isModalOpen = false;
      this.ref = this.modalService.open(AlertConfirmPopupComponent, this.ngbModalOptions);
      this.ref.componentInstance.title = this.authoringContentData.manageLine.autoRenewOffheadertest;
      this.ref.componentInstance.message = this.authoringContentData.manageLine.autoRenewOff.replace('{{enddate}}',endDate);
      this.ref.componentInstance.modalFootershow = false;
    }else if(autoRenew === MANAGE_LINE_CONST.AUTO_PAY_ON){
      this.alertModal.isModalOpen = false;
      this.ref = this.modalService.open(AlertConfirmPopupComponent, this.ngbModalOptions);
      this.ref.componentInstance.title = this.authoringContentData.manageLine.autoRenewOnheadertest;
      this.ref.componentInstance.message = this.authoringContentData.manageLine.autoRenewOn.replace('{{renewaldate}}',renewalDate);
      this.ref.componentInstance.modalFootershow = false;
    }
  } 
  getBillingMethod(product){
    if(product?.recurringFrequency?.toLowerCase() == COMMON_CONSTANTS.ONE_TIME_TEXT && product.agreements?.chargeUpfront){
      return this.authoringContentData.manageLine.upFrontCta;
    }else if(product?.recurringFrequency?.toLowerCase() == COMMON_CONSTANTS.ONE_TIME_TEXT && !product.agreements?.chargeUpfront){
      return this.authoringContentData.manageLine.oneTimeCta;
    }else{
      return product?.recurringFrequency || COMMON_CONSTANTS.DOUBLE_HYPHEN;
    }
  }

  checkEllipsisActive(e: HTMLElement): boolean {  
    return e ? (e.offsetWidth < e.scrollWidth) : false;
  }

  sortOfficeName(ofc1, ofc2) {
    const ofcnameA = /^[a-zA-Z]+$/.test(ofc1);
    const ofcnameB = /^[a-zA-Z]+$/.test(ofc2);
      if (ofcnameA && ofcnameB) {
        return ofc1.localeCompare(ofc2);
      }
      const ofcIdA = !isNaN(ofc1);
      const ofcIdB = !isNaN(ofc2);
      if (ofcIdA && ofcIdB) {
        return Number(ofc1) - Number(ofc2);
      }
      if (ofcIdB) {
        return -1;
      } else {
        return 1;
      }
  }

  showNoLinesPopUp(clickFlow) {  
    
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
        
    const modelRef = this.modalService.open(NoLinesModalComponent, this.ngbModalOptions);
    modelRef.componentInstance.isDialPad = true;
    modelRef.componentInstance.clickFlow = clickFlow;
  }
}
